/**
 * Article Table of Contents - Improved for Dawn 15.x
 */
(function() {
  'use strict';

  const TOC = {
    init() {
      this.headings = document.querySelectorAll('.article-template__content h2');
      this.sidebarTOC = document.querySelector('.sidebar-toc');
      this.inlineTOC = document.querySelector('.inline-toc__links');
      
      if (this.headings.length === 0) return;
      
      this.buildTOC();
      this.setupScrollSpy();
      this.setupSmoothScroll();
      this.setupMobileToggle();
      this.setupReadingProgress();
    },

    buildTOC() {
      this.headings.forEach((heading, index) => {
        const id = `section-${index}`;
        heading.id = id;
        heading.classList.add('toc-anchor');

        if (this.sidebarTOC) {
          const link = document.createElement('a');
          link.href = `#${id}`;
          link.textContent = heading.textContent;
          link.classList.add('sidebar-toc__link');
          link.dataset.index = index;
          this.sidebarTOC.appendChild(link);
        }

        if (this.inlineTOC) {
          const link = document.createElement('a');
          link.href = `#${id}`;
          link.textContent = heading.textContent;
          link.classList.add('inline-toc__link');
          this.inlineTOC.appendChild(link);
        }
      });
    },

    setupScrollSpy() {
      if (!this.sidebarTOC) return;

      const observerOptions = {
        root: null,
        rootMargin: '-20% 0px -60% 0px',
        threshold: 0
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const id = entry.target.id;
            this.setActiveLink(id);
          }
        });
      }, observerOptions);

      this.headings.forEach(heading => observer.observe(heading));
    },

    setActiveLink(id) {
      document.querySelectorAll('.sidebar-toc__link').forEach(link => {
        link.classList.remove('active');
        if (link.getAttribute('href') === `#${id}`) {
          link.classList.add('active');
        }
      });

      document.querySelectorAll('.inline-toc__link').forEach(link => {
        link.classList.remove('active');
        if (link.getAttribute('href') === `#${id}`) {
          link.classList.add('active');
        }
      });
    },

    setupSmoothScroll() {
      const allLinks = document.querySelectorAll('.sidebar-toc__link, .inline-toc__link');
      
      allLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          const targetId = link.getAttribute('href').slice(1);
          const target = document.getElementById(targetId);
          
          if (target) {
            const headerOffset = 120;
            const elementPosition = target.getBoundingClientRect().top;
            const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

            window.scrollTo({
              top: offsetPosition,
              behavior: 'smooth'
            });
          }
        });
      });
    },

    setupMobileToggle() {
      const toggle = document.querySelector('.inline-toc__toggle');
      const content = document.querySelector('.inline-toc__content');
      
      if (toggle && content) {
        toggle.addEventListener('click', () => {
          content.classList.toggle('is-open');
          toggle.classList.toggle('is-open');
          toggle.setAttribute('aria-expanded', content.classList.contains('is-open'));
        });
      }
    },

    setupReadingProgress() {
      const progressBar = document.querySelector('.reading-progress__bar');
      if (!progressBar) return;

      const article = document.querySelector('.article-template__content');
      if (!article) return;

      window.addEventListener('scroll', () => {
        const articleTop = article.offsetTop;
        const articleHeight = article.offsetHeight;
        const windowHeight = window.innerHeight;
        const scrollTop = window.pageYOffset;

        const start = articleTop - windowHeight;
        const end = articleTop + articleHeight - windowHeight;
        const progress = Math.min(Math.max((scrollTop - start) / (end - start) * 100, 0), 100);

        progressBar.style.width = `${progress}%`;
      }, { passive: true });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => TOC.init());
  } else {
    TOC.init();
  }
})();
